module.exports = __webpack_public_path__ + "static/media/forest.06d77008.jpg";